module.exports = __webpack_public_path__ + "2aa5974ee00de6576191e5c88862511a.svg";